import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';
import cx from 'classnames';

import { computeMediaHasFailed } from '../../utils/normalizeMediaStatus';
import getImageStatusLabelKey from '../../utils/getImageStatusLabelKey';
import * as styles from './ImageStatusBadge.scss';

const ImageStatusBadge = ({ status, error, className, compact, translate }) => {
  const hasError = computeMediaHasFailed({ status, error });
  const labelKey = getImageStatusLabelKey({ hasError, compact });

  return (
    <div
      className={cx(compact ? styles.compact : styles.full, className, {
        [styles.failed]: hasError,
        [styles.processing]: !hasError
      })}
    >
      <i className={hasError ? 'icon icon-exclamation' : 'icon icon-om-spinner om-pulse'} />
      <span>{translate(labelKey)}</span>
    </div>
  );
};

ImageStatusBadge.propTypes = {
  status: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  compact: PropTypes.bool,
  translate: PropTypes.func.isRequired,
  className: PropTypes.string
};

const mapStateToProps = state => ({
  translate: getLang(state.lang, 'static', 'image')
});

export default connect(mapStateToProps)(ImageStatusBadge);
